import Vue from 'vue';
import App from './App.vue';
import vuetify from '@/plugins/vuetify';
import router from '@/routes/index';
import store from '@/store/index';
// import LoadScript from 'vue-plugin-load-script';
// import { errorLogout } from '@/utils/errorUtil';
global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

Vue.config.productionTip = false;

Vue.config.errorHandler = e => {
  alert(`오류가 발생했습니다 (${e})`);
  // console.log('Main.js errorHandler');
  console.log(e);
  store.commit('SPINNER/OFF_COMMON_SPINNER');
  store.commit('SPINNER/OFF_APP_SPINNER');

  // errorLogout();
};

// Vue.config.warnHandler = e => {
//   console.log(e);
// };

Vue.prototype.$domain =
  process.env.NODE_ENV === 'production'
    ? `${window.location.protocol}//${window.location.host}/mobile/`
    : process.env.VUE_APP_API_URL;

const vm = new Vue({
  render: h => h(App),
  vuetify,
  router,
  store,
  // LoadScript,
}).$mount('#app');

window.app = vm;
